import { useTranslation } from 'react-i18next'

import { ComboBox, shipmentStatusLabels } from '@reveni-io/reveni-ui'

import { statusesByDirection } from './constants'

const ParcelStatusSelector = ({ onChange, value = [], direction }) => {
  const { t } = useTranslation()
  const statuses = statusesByDirection[direction]

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <div>
      <ComboBox
        value={value || []}
        label={t('Estado de envío')}
        fullWidth
        multiple
        handleChange={handleChange}
        menuItems={statuses.map(s => ({ label: t(shipmentStatusLabels[s]), value: s }))}
        placeholder={t('Todos')}
      />
    </div>
  )
}

export default ParcelStatusSelector
